import { render, staticRenderFns } from "./HomeProprietaire.vue?vue&type=template&id=561f4a5f&"
import script from "./HomeProprietaire.vue?vue&type=script&lang=js&"
export * from "./HomeProprietaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports